export default __webpack_public_path__ + "static/flag_b.c61abbddcc03c20d7c0cf27bf0e11fce.png";